// MyContext.js
import React from 'react';

const AIOContext = React.createContext();

export default AIOContext;
